import { motion } from "framer-motion";
import { Search, X } from "lucide-react";

export function TopBar({ members, levels, departments, query, matchCount, onQuery, isLight, C }) {
  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 18, delay: 0.15 }}
        className="pointer-events-none absolute left-6 top-5 z-40"
      >
        <div className="flex items-center gap-3">
          <div
            className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-xl border backdrop-blur-sm shadow-sm overflow-hidden"
            style={{
              background: isLight ? "#ffffff" : "rgba(255,255,255,0.05)",
              borderColor: isLight ? "rgba(15,23,42,0.08)" : "rgba(255,255,255,0.1)",
            }}
          >
            <img src="/iSource LOGO1.png" alt="iSource" className="h-full w-full object-contain" />
          </div>
          <div>
            <h1
              className="font-['Space_Grotesk'] text-[20px] font-semibold leading-none tracking-[0.02em]"
              style={{ color: isLight ? "#0f172a" : "#ffffff" }}
            >
              i<span style={{ color: C.accent }}>Source</span>
            </h1>
            <p
              className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em]"
              style={{ color: isLight ? "rgba(15,23,42,0.45)" : "rgba(255,255,255,0.35)" }}
            >
              Organization Studio
            </p>
          </div>
        </div>
        <div
          className={
            "pointer-events-auto mt-3.5 flex items-center gap-4 rounded-xl border px-3.5 py-2 backdrop-blur-xl"
          }
          style={{
            borderColor: isLight ? "rgba(15,23,42,0.08)" : "rgba(255,255,255,0.07)",
            background: isLight ? "rgba(255,255,255,0.75)" : "rgba(14,15,19,0.6)",
          }}
        >
          <Stat label="Members" value={members} isLight={isLight} />
          <Divider isLight={isLight} />
          <Stat label="Levels" value={levels} isLight={isLight} />
          <Divider isLight={isLight} />
          <Stat label="Teams" value={departments} isLight={isLight} />
        </div>
      </motion.header>

      <motion.div
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 18, delay: 0.25 }}
        className="absolute right-6 top-5 z-40"
      >
        <div
          className="flex items-center gap-2 rounded-xl border px-3 py-2 shadow-lg backdrop-blur-xl transition-colors focus-within:border-[rgba(37,99,235,0.5)]"
          style={{
            borderColor: isLight ? "rgba(15,23,42,0.08)" : "rgba(255,255,255,0.09)",
            background: isLight ? "rgba(255,255,255,0.85)" : "rgba(14,15,19,0.75)",
          }}
        >
          <Search
            size={14}
            className="shrink-0"
            style={{ color: isLight ? "rgba(15,23,42,0.4)" : "rgba(255,255,255,0.4)" }}
          />
          <input
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            placeholder="Search people, roles, teams…"
            className="w-48 bg-transparent text-[12.5px] outline-none"
            style={{
              color: isLight ? "rgba(15,23,42,0.85)" : "rgba(255,255,255,0.85)",
            }}
          />
          {query && (
            <>
              <span
                className="rounded px-1.5 py-0.5 font-mono text-[10px]"
                style={{ background: C.accentBg, color: C.accent }}
              >
                {matchCount}
              </span>
              <button
                onClick={() => onQuery("")}
                aria-label="Clear search"
                className="transition-colors"
                style={{
                  color: isLight ? "rgba(15,23,42,0.45)" : "rgba(255,255,255,0.4)",
                }}
              >
                <X size={13} />
              </button>
            </>
          )}
        </div>
      </motion.div>
    </>
  );
}

function Stat({ label, value, isLight }) {
  return (
    <div className="flex items-baseline gap-1.5">
      <span
        className="font-['Space_Grotesk'] text-[15px] font-semibold tabular-nums"
        style={{ color: isLight ? "rgba(15,23,42,0.9)" : "rgba(255,255,255,0.9)" }}
      >
        {value}
      </span>
      <span
        className="font-mono text-[8.5px] uppercase tracking-[0.22em]"
        style={{ color: isLight ? "rgba(15,23,42,0.4)" : "rgba(255,255,255,0.35)" }}
      >
        {label}
      </span>
    </div>
  );
}

function Divider({ isLight }) {
  return (
    <span
      className="h-4 w-px"
      style={{ background: isLight ? "rgba(15,23,42,0.08)" : "rgba(255,255,255,0.08)" }}
    />
  );
}
